import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate, Outlet, useLocation } from "react-router";
import { ROUTES } from "../shared/routes";
import { ErrorBoundary } from "../components/ErrorBoundary";

const ProtectedArea = () => {
  const { user } = useContext(AuthContext)!;
  const location = useLocation();

  return user ? (
    // A route change must recover from a failed page rather than keeping the
    // shared protected boundary latched. Sidebar/auth stay mounted outside it.
    <ErrorBoundary key={location.pathname}>
      <Outlet />
    </ErrorBoundary>
  ) : (
    <Navigate to={ROUTES.SIGN_IN} state={{ from: location }} replace />
  );
};

export default ProtectedArea;
